import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'Establishment';
const ENDPOINT = `/establishments/`;

@Injectable({
    providedIn: 'root'
})
export class EstablishmentService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
